import { type IntlShape } from 'react-intl'

import { type OfferV11 } from '@redteclab/api/clients/bully'

export const priceAccessorGetFormattedUnitPrice = (
  offer: OfferV11,
  intl: IntlShape,
): string | null => {
  if (offer.offerPrice?.basePrice?.amount === undefined) {
    return null
  }

  const { amount, currency, unit, value } = offer.offerPrice.basePrice

  // we need to change 'st' to 'St.' for german shops since the nouns should start with capital
  const formattedUnit =
    unit === 'st'
      ? intl.formatMessage({ id: 'product.attribute.unit.pcs' })
      : unit

  const basePrice = intl.formatNumber(amount, {
    currency,
    style: 'currency',
  })

  return `${basePrice} / ${value}\u{A0}${formattedUnit}`
}
